export const memorizedParams = (() => {
  let cache = {}

  return (params) => {
    if (params) {
      Object.keys(params).forEach((key) => {
        if (params[key]) {
          cache[key] = params[key]
        }
      })
      return cache
    }
    return cache
  }
})()
